import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';

import type {
  StateType,
  ActionType,
} from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';

export const actionSanitizer = (action: ActionType) =>
  action.type === MUTATION_RESPONSE_RECEIVED || action.type === QUERY_RESPONSE_RECEIVED
    ? {
        type: action.type,
        payload: {
          ...action.payload,
          response: { ...action.payload.response, body: '<PAYLOAD_BODY>' },
        },
      }
    : action;

export const stateSanitizer = (state: StateType) => ({
  ...state,
  shared: {
    ...state.shared,
    network: {
      mutations: '<MUTATION_STATE>',
      queries: '<QUERY_STATE>',
    },
  },
});
